import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ExpandMore from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '40px',
    backgroundColor: theme.palette.white,

    color: theme.palette.grey.dark,
    '&:before': {
      display: 'none'
    },
    '&:after': {
      display: 'none'
    },
    '&:hover': {
      color: theme.palette.primary.main
    }
  },
  input: {
    border: `2px solid ${theme.palette.grey.medium}`,
    borderRadius: '4px',
    paddingLeft: '16px',
    boxSizing: 'border-box',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      borderColor: theme.palette.accent.main
    },
    '&:focus': {
      backgroundColor: theme.palette.white,
      borderRadius: '4px'
    }
  },
  icon: {
    color: 'inherit',
    right: '8px'
  },
  optionsListContainer: {
    border: `2px solid ${theme.palette.primary.main}`,
    boxSizing: 'content-box',
    paddingRight: '1px',
    '& .Mui-selected': {
      backgroundColor: theme.palette.white,
      color: theme.palette.grey.dark,
      '&:hover': {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.accent.main
      }
    },
    '& .Mui-disabled': {
      opacity: '1',
      color: theme.palette.primary.main
    }
  },
  optionsList: {
    paddingTop: '0',
    paddingBottom: '0',
    '& li': {
      fontSize: '.925rem',
      color: theme.palette.grey.dark
    },
    '& li:first-child': {
      height: '38px'
    },
    '& li:focus': {
      backgroundColor: 'inherit'
    },
    '& li:hover': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.accent.main
    }
  },
  label: {
    fontSize: '.85rem'
  },
  select: {
    paddingRight: '32px !important'
  }
}));

const DropdownInput = ({ options, label, selected, onSelect, ...rest }) => {
  const classes = useStyles();

  return (
    <Select
      value={selected || ''}
      className={classes.root}
      label={label}
      classes={{
        root: classes.input,
        icon: classes.icon,
        select: classes.select
      }}
      IconComponent={ExpandMore}
      onChange={onSelect}
      MenuProps={{
        classes: {
          paper: classes.optionsListContainer,
          list: classes.optionsList
        }
      }}
      {...rest}
    >
      <MenuItem value="" disabled>
        <span className={classes.label}>{label}</span>
      </MenuItem>
      {options &&
        options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
    </Select>
  );
};

DropdownInput.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.exact({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired,
  label: PropTypes.string,
  selected: PropTypes.string,
  onSelect: PropTypes.func.isRequired
};

DropdownInput.defaultProps = {
  label: 'Choose item(s)...',
  selected: null
};

export default DropdownInput;
